<template>
  <section class="survey-journey">
    <header class="d-flex justify-content-between p-5">
      <div class="d-flex align-items-center title-container">
        <input
          class="text-capitalize px-4"
          v-if="editTitle"
          autofocus
          ref="titleInput"
          v-model="titleText"
          @keyup.enter="handleEdit()"
        />
        <h2 class="text-capitalize title m-0 px-5" v-else>{{ title }}</h2>
        <span
          class="
            edit-title
            font-20
            cursor-pointer
            d-block
            ms-5
            py-2
            text-center
          "
          @click="handleEdit()"
          >Edit Title</span
        >
      </div>
      <div class="d-flex align-items-center justify-content-end">
        <div class="row">
          <div class="text-end">
            <span @click="$router.go(-1)" class="cursor-pointer">
              <close-svg />
            </span>
          </div>
        </div>
      </div>
    </header>
    <section class="container">
      <div class="px-5 pb-5">
        <ul
          class="
            list-unstyled
            border-0
            d-flex
            align-items-center
            flex-nowrap
            nav nav-tabs
          "
          id="myTab"
          role="tablist"
        >
          <li role="presentation">
            <a
              class="
                nav-link
                font-20
                position-relative
                text-center
                active
                nav-item
                py-3
                px-5
                text-capitalize
              "
              @click="changeStyleOfVisitedTab($event)"
              id="core-tab"
              data-bs-toggle="tab"
              data-bs-target="#core"
              type="button"
              role="tab"
              aria-controls="core"
              aria-selected="true"
            >
              Core Question
            </a>
          </li>
          <li class="line"></li>
          <li role="presentation">
            <a
              class="
                nav-link
                position-relative
                text-center
                nav-item
                py-3
                px-5
                text-capitalize
              "
              @click="changeStyleOfVisitedTab($event)"
              id="custom-tab"
              data-bs-toggle="tab"
              data-bs-target="#custom"
              type="button"
              role="tab"
              aria-controls="custom"
              aria-selected="false"
            >
              Custom Question
            </a>
          </li>
          <li class="line"></li>
          <li role="presentation" v-if="finalizeActive">
            <a
              class="
                nav-link
                position-relative
                text-center
                nav-item
                py-3
                px-5
                text-capitalize
              "
              @change="changeStyleOfVisitedTab($event)"
              id="finalize-tab"
              data-bs-toggle="tab"
              data-bs-target="#finalize"
              type="button"
              role="tab"
              aria-controls="finalize"
              aria-selected="false"
            >
              finalize
            </a>
          </li>
          <li role="presentation" v-else>
            <a
              class="
                nav-link
                position-relative
                text-center
                nav-item
                py-3
                px-5
                text-capitalize
              "
              @click="changeStyleOfVisitedTab($event)"
            >
              finalize
            </a>
          </li>
        </ul>
      </div>

      <div class="survey-container px-5">
        <div class="tab-content text-danger" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="core"
            role="tabpanel"
            aria-labelledby="core-tab"
          >
            <CoreQuestions />
          </div>
          <div
            class="tab-pane fade"
            id="custom"
            role="tabpanel"
            aria-labelledby="custom-tab"
          >
            <CustomQuestion />
          </div>
          <div
            class="tab-pane fade"
            id="finalize"
            role="tabpanel"
            aria-labelledby="finalize-tab"
          >
            <Finalize />
          </div>
        </div>
      </div>
    </section>

    <transition name="fade">
      <div
        v-if="surveyValuesNotInvalid"
        class="
          modal-layout
          position-fixed
          d-flex
          justify-content-center
          align-items-center
        "
      >
        <div class="p-5 survey-journey-popup w-50 text-center">
          <h2 class="w-75 m-auto">
            You must select Product and CustomerGroup first
          </h2>
          <router-link
            class="px-4 py-3 mx-auto d-block survey-journey-popup-button mt-5"
            :to="{ name: 'SelectSurveyType' }"
            >Ok</router-link
          >
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import CoreQuestions from "@/components/create-survey-journey/core-questions.vue";
import CustomQuestion from "@/components/create-survey-journey/custom-question.vue";
import Finalize from "@/components/create-survey-journey/finalize.vue";
import { mapGetters } from "vuex";
import PlaceholderManager from "@/manager/placeholderManager";

export default {
  name: "SurveyJourney",
  components: {
    CoreQuestions,
    CustomQuestion,
    Finalize,
  },
  provide() {
    return {
      allPlaceholders: () => this.allPlaceholder,
      allPlaceholderKey: () => this.questionPlaceholderKeys,
      placeholderValues: () => this.allPlaceholderValues,
      applyPlaceholder: this.handleApplyPlaceholder,
      finalizeStatus: this.handleFinalizeStatus,
      addPlaceholder: this.addNewPlaceholder,
    };
  },
  data() {
    return {
      editTitle: false,
      titleText: "",
      allPlaceholder: [],
      finalizeActive: false,
      allPlaceholderValues: [],
      surveyValuesNotInvalid: false,
    };
  },
  computed: {
    ...mapGetters("surveyJourney", {
      getterPlaceholders: "createFormPlaceholder",
      createFormValuesDataset: "createFormValuesDataset",
      coreQuestionsDataset: "coreQuestionsDataset",
      createFormPlaceholderValues: "createFormPlaceholderValues",
    }),
    title() {
      return this.$store.getters["surveyJourney/createFormValuesDataset"]
        .surveyName;
    },
    questionPlaceholderKeys() {
      let allQuestions = [
        ...this.coreQuestionsDataset,
        ...this.createFormValuesDataset.CustomerGroup?.demographicQuestions,
      ];

      const placeholderKeys = allQuestions
        .map((q) =>
          PlaceholderManager.questionPlaceholderKey(
            q.localizations["EN"].description
          )
        )
        .filter((value, index, self) => self.indexOf(value) === index)
        .filter((t) => t !== undefined);

      return placeholderKeys;
    },
  },
  methods: {
    changeStyleOfVisitedTab(e) {
      e.delegateTarget?.addEventListener("shown.bs.tab", function(event) {
        event.relatedTarget.style.background = "#42C1A9";
        event.target.style.background = "#fff";
      });
    },
    handleEdit() {
      this.editTitle = !this.editTitle;
      if (this.titleText.toLowerCase() !== this.title.toLowerCase()) {
        this.$store.dispatch("surveyJourney/changeTitle", {
          title: this.titleText,
        });
      }
      this.$refs.titleInput?.focus();
    },
    handleApplyPlaceholder(type, placeholder, placeholderValue) {
      if (type === "one") {
        const selectedPlaceholderItem = this.allPlaceholder.findIndex(
          (placeholderItem) => placeholderItem.placeholder === placeholder
        );
        this.allPlaceholder[selectedPlaceholderItem].value = placeholderValue;
      } else {
        this.allPlaceholder.forEach(
          (placeholderItem) => (placeholderItem.value = placeholderValue)
        );
      }
    },
    handleFinalizeStatus() {
      this.finalizeActive = true;
    },
    addNewPlaceholder(inputValue) {
      PlaceholderManager.addNewPlaceholder(
        inputValue,
        this.allPlaceholderValues
      );
    },
  },
  async mounted() {
    if (
      !this.createFormValuesDataset.Products &&
      !this.createFormValuesDataset.CustomerGroup &&
      !this.createFormValuesDataset.surveyName
    ) {
      // this.$router.push({ name: "SelectSurveyType" });
      this.surveyValuesNotInvalid = true;
    }
    try {
      await this.$store.dispatch("surveyJourney/getAllDemographicQuestions");
      await this.$store.dispatch("surveyJourney/getCoreQuestions");
      this.titleText = this.title;
      this.allPlaceholder = this.getterPlaceholders;
      this.allPlaceholderValues = this.createFormPlaceholderValues;
    } catch (error) {
      this.$store.dispatch("dialog/showErrorDialog", {
        error: error,
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.survey-journey {
  background-image: url(../../assets/images/create-survey/personas.png);
  background-repeat: no-repeat;
  background-position: top;
  background-size: contain;
}

header {
  .title-container {
    .edit-title {
      color: $color-white;
      opacity: 0;
      visibility: hidden;
      transition: $transition-400ms;
      transform: translateX(-80%);
      width: 9.375rem;
      border-radius: $radius-25;
    }

    &:hover {
      .edit-title {
        opacity: 1;
        visibility: visible;
        transform: translateX(0);
        &:hover {
          background-color: $color-white;
          color: $color-black;
        }
      }
    }
  }

  .title {
    height: 65px;
  }

  input {
    height: 65px;
    max-width: calc(100% - 9.375rem);
    font-size: $font-size-32;
    outline: unset;
    border: unset;
    color: $color-black;
    border-radius: $radius-34;
  }
}

.survey-container {
  height: calc(100vh - 18.75rem);
  overflow: auto;
}
.nav-tabs li {
  width: 20%;
}
.line {
  height: 1px;
  background-color: $color-white;
}
.nav-link.nav-item {
  min-width: max-content;
  display: block;
  border: $border-white-1;
  border-radius: $radius-34;
  font-weight: $font-weight-semiBold;
  cursor: pointer;
  transition: $transition-400ms;
  color: $color-white;
  text-decoration: none;
  z-index: 1;

  &:hover {
    color: $color-black !important;
    background: $color-white !important;
  }

  &.active {
    color: $color-black;
  }
}

::-webkit-scrollbar {
  width: 5px;
}

.link-visited {
  background: green !important;
}

.survey-journey-popup {
  border: $border-white-1;
  background-color: $color-grey-100;
  border-radius: $radius-20;
}

.survey-journey-popup-button {
  width: 200px;
  color: $color-white;
  border-radius: $radius-29;
  border: $border-white-1;
  background-color: $color-grey-100;

  &:hover {
    background-color: $color-white;
    color: $color-grey-100;
    transition: all 0.2s ease-in-out;
  }
}
</style>
